<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5 header_btn"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                @click="editRecord()"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'customer/edit/'+selectedRows[0].customer_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="mr-1">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-1 header_btn"
              >
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Logs</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg"
                @click="getVendorBalance('multi','')"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-calculator-variant-outline</v-icon>
                <span class="lable_class">Balance</span>
              </v-btn>
            </template>
            <span>Balance</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Customer
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              item-key="customer_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr :class="(!item.active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.customer_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.customer_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="17%">{{item.first_name}}</td>
                  <td width="17%">{{item.last_name}}</td>
                  <td width="13%">{{item.company_name}}</td>
                  <td width="10%">{{item.mobile_number}}</td>

                  <td width="5%" class="text-center">{{(item.email_alert)?'Yes':'No'}}</td>
                  <td width="9%"></td>
                  <td width="9%" class="text-right">
                    <span
                      v-if="item.customer_balance_flag==true"
                      :class="{
                        'error--text': item.balance   < 0,
                        'primary--text': item.balance > 0,
                      }"
                    >{{ item.balance != 0 ? '$'+ getAmountFormat(item.balance) : ''}}</span>
                    <v-btn
                      icon
                      x-small
                      v-else
                      href
                      class="pr-7"
                      @click="getCustomerBalance('single',item.customer_id)"
                    >view</v-btn>
                  </td>
                  <td width="5%" class="text-center">{{(item.active)?'Yes':'No'}}</td>
                  <td width="6%" class="text-center">{{item.multiplier}}</td>

                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.customer_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected customers?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteCustomers()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Add />
    <Edit />
    <Upload />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import Upload from "../document/Upload";
import DocList from "../document/List";
import LogList from "../log/List";
import { parseParams, logout } from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
export default {
  name: "CustomerList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      showMenu: false,
      search: "",
      items: {
        data: []
      },
      loading: false,
      delete_dialog: false,
      filter_menu: false,
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["first_name"],
        page: 1,
        filters: {
          item_active: "1",
          bill_to_company: false,
          alphabet: ""
        }
      },
      alphabets: [],
      expanded: [],
      search_menu: false
    };
  },
  components: {
    Add,
    Edit,
    Upload,
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("customer", ["add_modal", "edit_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        { value: "checkbox", text: "#", sortable: false, width: "3%" },
        {
          value: "first_name",
          text: "First Name",
          sortable: true,
          width: "17%"
        },
        { value: "last_name", text: "Last Name", sortable: true, width: "17%" },
        {
          value: "company_name",
          text: "Bill To Company",
          sortable: true,
          width: "13%"
        },
        {
          value: "",
          text: "Mobile",
          sortable: false,
          width: "10%",
          class: "pl-6"
        },
        { value: "", text: "Alert", sortable: false, width: "5%" },
        { value: "", text: "Amt. Due", sortable: false, width: "9%" },
        {
          value: "",
          text: "Balance",
          sortable: false,
          width: "9%",
          align: "right"
        },
        { value: "", text: "Active", sortable: false, width: "5%" },
        { value: "", text: "Multiplier", sortable: false, width: "6%" },
        { value: "", text: "", sortable: false, width: "3%" }
      ];
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "first_name";
      return paginationData;
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getCustomers();
    },
    pagination: {
      handler: function() {
        this.getCustomers();
      },
      deep: true
    },
    add_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_modal: function(value) {
      if (!value) {
        this.getCustomers();
      }
    }
  },
  methods: {
    ...mapMutations("customer", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    resetFilter() {
      this.search = "";
      this.pagination.filters.item_active = "1";
      this.getCustomers();
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.customer_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 6 });
      this.setDocumentData({ key: "o_id", value: item.customer_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 6 });
      this.setDocumentData({ key: "o_id", value: item.customer_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Customer" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: item.full_name });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "CUSTOMER" });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 6 });
      this.setLogData({ key: "o_id", value: item.customer_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Customer" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: item.full_name });

      this.setLogData({ key: "bank_name", value: "" });

      this.setLogData({ key: "project_name", value: "" });

      this.setLogData({ key: "vendor_name", value: "" });
    },
    addRecord() {
      this.setData({ key: "add_modal", value: true });
    },
    editRecord(customer_id, is_view_mode) {
      this.setData({ key: "edit_modal", value: true });
      this.setData({ key: "id", value: customer_id });
      this.setData({ key: "is_view_mode", value: is_view_mode });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=customer").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.customer_id == itemData.item.customer_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    deleteCustomers() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.customer_id);
      });
      axios
        .post("delete_customers", {
          ids: ids
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getCustomers();
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.$Progress.fail();
        });
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    getCustomerBalance(type, id) {
      let _self = this;
      this.loading = "accent";
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.selectedRows.map(function(item) {
          ids.push(item.customer_id);
        });
      }
      axios
        .get("get_customer_balance?customer_ids=" + ids)
        .then(response => {
          this.items.data = this.items.data.filter(item => {
            response.data.data.filter(fil => {
              if (item.customer_id == fil.customer_id) {
                console.log("fil.balance", fil.balance);
                item.balance = fil.balance;
                item.customer_balance_flag = true;
              }
            });

            return item;
          });
          this.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getCustomers() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("customer_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    //this.getAlphabets();
  }
};
</script>

<style scoped>
.btn-filter {
  width: auto;
}
</style>